import { useMutation, useQueryClient } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import api from '@pray/shared/utils/api';

import type { ChatbotResponse, PublishChatbotParams } from './types';

export async function publishChatbot({ artistId }: PublishChatbotParams): Promise<ChatbotResponse> {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/chatbot/publish`;
  const response = await api.executePostRequest<ChatbotResponse>(url, {});

  return response.data;
}

export function usePublishChatbot() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: publishChatbot,
    onSuccess: (_, { artistId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.artistChatbot(artistId),
      });
    },
  });

  const { mutateAsync, ...rest } = mutation;

  return {
    publishChatbot: mutateAsync,
    ...rest,
  };
}
